import React from "react";
import { useFormContext } from "react-hook-form";
import CField from "$forms/CField";
import { useDockyardStyles } from "../styles";

export const BasicInfoSection: React.FC = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const classes = useDockyardStyles();

  return (
    <>
      <div className={classes.newFormFieldsRow}>
        <div className={classes.newFormFieldsCol}>
          <CField
            control={control}
            label="Code chantier"
            name="code"
            rules={{
              pattern: {
                value:
                  /^[a-zA-Z0-9-/\\(\\)\\{\\}\\^\\$\\|\\?\\*\\+\\.\\<\\>\\-\\=\\!\\_àâêéèïôöùñ]*$/i,
                message: "Caractère(s) non autorisé(s)",
              },
            }}
            required
            error={errors.code}
          />
        </div>
        <div className={classes.newFormFieldsCol}>
          <CField
            label="Nom chantier"
            control={control}
            name="name"
            required
            error={errors.name}
          />
        </div>
      </div>
      <div className={classes.newFormFieldsRow}>
        <div className={classes.newFormFieldsCol}>
          <CField
            control={control}
            name="codeAnalytics"
            label="Code analytique"
            rules={{
              pattern: {
                value: /^[a-zA-Z0-9]*$/,
                message:
                  "Caractère(s) non autorisé(s): Alphanumérique obligatoire",
              },
            }}
            error={errors.codeAnalytics}
          />
        </div>
      </div>
    </>
  );
};
